module.exports = __webpack_public_path__ + "img/gdszy.04773287.png";